import { apiClient } from '../../../shared/api/axios-instance'
import type { Brand } from '../types/brand.types'

export interface CreateBrandData {
    name: string
    description?: string
    logo?: string
    status?: 'active' | 'inactive'
}

export interface UpdateBrandData {
    name?: string
    description?: string
    logo?: string
    status?: 'active' | 'inactive'
}

const mapBrand = (item: any): Brand => ({
    id: String(item.id),
    name: item.name,
    description: item.description || '',
    logo: item.logo,
    logoUrl: item.logo_url,
    productCount: item.products_count || 0,
    status: item.status || (item.is_active ? 'active' : 'inactive'),
    createdAt: item.created_at,
})

const brandService = {
    /**
     * Get all brands
     */
    async getBrands(): Promise<Brand[]> {
        const response = await apiClient.get('admin/catalog/brands')
        return response.data.data.map(mapBrand)
    },

    /**
     * Get brand details
     */
    async getBrand(id: string): Promise<Brand> {
        const response = await apiClient.get(`admin/catalog/brands/${id}`)
        return mapBrand(response.data.data)
    },

    /**
     * Create a new brand
     */
    async createBrand(data: CreateBrandData): Promise<Brand> {
        const response = await apiClient.post('admin/catalog/brands', data)
        return mapBrand(response.data.data)
    },

    /**
     * Update a brand
     */
    async updateBrand(id: string, data: UpdateBrandData): Promise<Brand> {
        const response = await apiClient.put(`admin/catalog/brands/${id}`, data)
        return mapBrand(response.data.data)
    },

    /**
     * Delete a brand
     */
    async deleteBrand(id: string): Promise<void> {
        await apiClient.delete(`admin/catalog/brands/${id}`)
    },
}

export default brandService
